<template>
  <v-row class="pa-10 pl-8 d-flex text-body-1">
    <v-col v-if="agentDisplayPic?.length" cols="auto">
      <v-img :src="agentDisplayPic" alt="agent photo" height="145" width="145" />
    </v-col>
    <v-col
      v-if="
        agentNameAndDesignation?.length ||
        repUrl?.length ||
        agentWorkPhone?.length ||
        agentDataRetreived?.preferences?.isdisplaymobilenumber ||
        agentDataRetreived?.agentInfo?.email?.length ||
        shouldDisplayScheduleLink
      "
      cols="auto"
    >
      <p v-if="agentNameAndDesignation?.length" class="font-weight-bold">
        {{ agentNameAndDesignation }}
      </p>
      <a v-if="repUrl?.length" class="" :href="!isPreview ? repUrl : undefined" target="_blank">{{
        repUrl
      }}</a>
      <div v-if="agentWorkPhone?.length" class="text-body-2">
        <v-icon size="18" color="blue600" class="mr-2">{{ mdiPhone }}</v-icon
        >{{ $t(Translations.office) }} : {{ agentWorkPhone }}
      </div>
      <div v-if="agentDataRetreived?.preferences?.isdisplaymobilenumber" class="mt-1 text-body-2">
        <v-icon size="18" color="blue600" class="mr-2">{{ mdiPhone }}</v-icon
        >{{ $t(Translations.mobile) }} : {{ agentMobile }}
      </div>
      <div v-if="agentDataRetreived?.agentInfo?.email?.length" class="mt-1 text-body-2">
        <a class="text-decoration-none" @click="composeEmail('')"
          ><v-icon size="18" color="blue600" class="mr-2">{{ mdiEmail }}</v-icon
          >{{ agentDataRetreived?.agentInfo?.email }}</a
        >
      </div>
      <div v-if="shouldDisplayScheduleLink" class="mt-1 text-body-2">
        <a :href="scheduleLinkAddress" class="text-decoration-none" target="_blank"
          ><v-icon size="18" color="blue600" class="mr-2">{{ mdiCalendarToday }}</v-icon
          >{{ $t(Translations.scheduleAnAppointment) }}</a
        >
      </div>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import type { CRMAgentDetails, LandingPages } from '@/interfaces/PegaAgent';
import { Translations } from '@/i18n/models';
import { defineComponent, type PropType } from 'vue';
import { formatAgentTitle, formatMobileNumber, composeEmail } from '@/utils/common';
import { mdiEmail, mdiPhone, mdiCalendarToday } from '@mdi/js';

const REP_WEBSITE = 'RepWebsite';

export default defineComponent({
  props: {
    agentDataRetreived: {
      type: Object as PropType<CRMAgentDetails | null>,
      default: null,
      required: true,
    },
    isPreview: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      Translations,
      mdiPhone,
      mdiEmail,
      mdiCalendarToday,
      composeEmail,
    };
  },
  computed: {
    agentTitleFormat(): string {
      if (!this.agentDataRetreived?.preferences.title) return '';
      return formatAgentTitle(this.agentDataRetreived.preferences.title);
    },
    agentDisplayPic(): string {
      return this.agentDataRetreived?.preferences.photourl
        ? `${this.agentDataRetreived.preferences.photourl}?_cb=${Date.now()}`
        : '';
    },
    agentNameAndDesignation(): string {
      if (!this.agentDataRetreived?.agentInfo.agentname) return '';
      return (
        this.agentDataRetreived.agentInfo.agentname +
        (this.agentDataRetreived.preferences.isdisplaytitle ? `, ${this.agentTitleFormat}` : '')
      );
    },
    agentWorkPhone(): string {
      if (!this.agentDataRetreived?.agentInfo.workphone) return '';
      return `(${this.agentDataRetreived.agentInfo.workphone.slice(0, 3)}) ${this.agentDataRetreived.agentInfo.workphone.slice(3, 6)}-${this.agentDataRetreived.agentInfo.workphone.slice(6)}`;
    },
    agentMobile(): string {
      return formatMobileNumber(this.agentDataRetreived?.preferences.mobilenumber);
    },
    repUrl(): string {
      return (
        this.agentDataRetreived?.preferences.landingpages.find((lp: LandingPages) =>
          lp.name.includes(REP_WEBSITE)
        )?.url ?? ''
      );
    },
    shouldDisplayScheduleLink(): boolean {
      return !!(
        this.agentDataRetreived?.preferences.schedulelink &&
        this.agentDataRetreived.preferences.isdisplayschedulelink
      );
    },
    scheduleLinkAddress() {
      if (this.isPreview) return;
      return this.agentDataRetreived?.preferences.schedulelink;
    },
  },
});
</script>
